var map = {
	"./determine/Detoxification.jpg": 35175,
	"./determine/Hydration.jpg": 51232,
	"./determine/MentalFitness.jpg": 61437,
	"./determine/Movement.jpg": 26645,
	"./determine/Nature.jpg": 31123,
	"./determine/Nutrition.jpg": 43770,
	"./determine/Relationships.jpg": 90553,
	"./determine/RestSelfCare.jpg": 27029,
	"./determine/Sleep.jpg": 11884,
	"./determine/Vision.jpg": 43801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74613;